import { MapPin, ArrowRight, Utensils, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BranchSelectionModal({ isOpen, onClose, branches = [], franchise = null }) {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleSelectBranch = (branch) => {
        if (!branch) return;
        localStorage.setItem('active_branch_slug', branch.slug);
        localStorage.setItem('tenant_slug', branch.slug);
        if (onClose) onClose();

        const hostname = window.location.hostname;
        const protocol = window.location.protocol;
        
        let targetDomain = '';
        if (branch.custom_frontend_url) {
            targetDomain = branch.custom_frontend_url.replace(/\/$/, '');
        } else if (hostname.endsWith('aaharamcloud.com')) {
            targetDomain = `${protocol}//${branch.slug}.aaharamcloud.com`;
        } else if (hostname.includes('vercel.app')) {
            const parts = hostname.split('.');
            const baseHost = parts.slice(1).join('.');
            targetDomain = `${protocol}//${branch.slug}.${baseHost}`;
        }

        if (targetDomain && targetDomain !== window.location.origin) {
            const token = localStorage.getItem('token');
            if (token) {
                window.location.href = `${targetDomain}/login?token=${token}&redirect=/orders`;
            } else {
                window.location.href = `${targetDomain}/`;
            }
            return;
        }

        navigate(`/branch/${branch.slug}`);
        window.location.reload();
    };

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-2xl w-full shadow-2xl border border-slate-100 space-y-6 max-h-[90vh] overflow-y-auto relative animate-in zoom-in-95 duration-200">
                {onClose && (
                    <button
                        onClick={onClose}
                        className="absolute top-6 right-6 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                )}

                <div className="text-center space-y-2 pt-2">
                    <div className="mx-auto w-14 h-14 bg-primary-50 text-primary-600 rounded-2xl flex items-center justify-center mb-4 shadow-sm">
                        <Utensils className="w-7 h-7" />
                    </div>
                    <h2 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
                        Select Branch Location
                    </h2>
                    <p className="text-sm text-slate-500 max-w-md mx-auto">
                        Orders must be placed directly with a specific branch location to ensure accurate menu availability and delivery rates.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                    {branches.map((branch) => (
                        <div
                            key={branch.id}
                            onClick={() => handleSelectBranch(branch)}
                            className="bg-slate-50 hover:bg-primary-50/60 border border-slate-200 hover:border-primary-400 p-5 rounded-2xl transition-all duration-200 cursor-pointer flex flex-col justify-between group shadow-sm hover:shadow-md"
                        >
                            <div className="space-y-2">
                                <div className="flex items-center justify-between">
                                    <span className="text-[10px] font-black uppercase tracking-wider bg-slate-200 group-hover:bg-primary-600 group-hover:text-white px-2.5 py-1 rounded-full text-slate-700 transition-colors">
                                        {branch.city || 'Chennai'}
                                    </span>
                                </div>
                                <h3 className="text-lg font-bold text-slate-900 group-hover:text-primary-700 transition-colors">
                                    {branch.name}
                                </h3>
                                <p className="text-xs text-slate-500 flex items-start gap-1">
                                    <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                                    <span>{branch.address || 'Location address details'}</span>
                                </p>
                            </div>

                            <div className="mt-4 pt-3 border-t border-slate-200/60 flex items-center justify-between text-xs font-bold text-primary-600 group-hover:text-primary-700">
                                <span>Go to Branch Store</span>
                                <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                            </div>
                        </div>
                    ))}
                </div>

                {branches.length === 0 && (
                    <div className="text-center py-8 text-slate-400 italic text-sm">
                        No active branch locations found for this franchise brand.
                    </div>
                )}
            </div>
        </div>
    );
}
